module.exports = __webpack_public_path__ + "static/media/location81d68983.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/location.svg
// module id = 1475
// module chunks = 0